import { createApp, type DefineComponent } from 'vue'
import request, { setupRequestStore } from '@/request'

import 'ant-design-vue/dist/reset.css'
import '@/styles/index.css'
import '@/utils/rem'

import App from './App.vue'
import router from './router'
import pinia from '@/stores/index'
import { useUserStore } from '@/stores/user'
import disabled from '@/directives/disabled'
import permission from '@/directives/permissions'
import { registerEcharts } from '@/plugins/echarts'
import { setupVxeTable } from '@/plugins/vxe-table'
const app = createApp(App)

app.config.globalProperties.$http = request
app.use(pinia)
setupRequestStore(useUserStore)
app.use(router)
app.directive('disabled', disabled)
app.directive('permission', permission)
app.use(registerEcharts)
setupVxeTable(app)

const components = import.meta.glob('./components/**/*.vue', { eager: true })
Object.entries(components).forEach(([path, module]) => {
  const componentName =
    (module as { default: DefineComponent }).default?.name ||
    path
      .split('/')
      .pop()
      ?.replace(/\.\w+$/, '')
  if (componentName) {
    app.component(componentName, (module as { default: DefineComponent }).default)
  }
})

app.mount('#app')
